export const PERMISSION_MESSAGE = "You don't have permission to do this task. Please consult your admin";
export const checkMultiPermissions = (allowedPermissions, userPermissions) => {
    return userPermissions.some(permission => allowedPermissions.includes(permission));
};

export const checkSinglePermission = (allowedPermission, userPermissions, role) => {
    if (role === "admin") return true;

    if (!Array.isArray(userPermissions) || userPermissions.length === 0) return false;

    return userPermissions.includes(allowedPermission);
};
